import { render, staticRenderFns } from "./LoggedInUser.vue?vue&type=template&id=6d09203b"
import script from "./LoggedInUser.vue?vue&type=script&lang=js"
export * from "./LoggedInUser.vue?vue&type=script&lang=js"
import style0 from "./LoggedInUser.vue?vue&type=style&index=0&id=6d09203b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports